var a=["a","an","and","at","but","by","for","if","in","of","on","or","the","to","via"];export{a as nonCapitalisedWords};
//# sourceMappingURL=nonCapitalisedWords.js.map
